module.exports = __webpack_public_path__ + "static/media/unitedkingdom.7fac5a13.svg";